import React from 'react';
import { clsx, createUseStyles, multiply } from '@pushpay/styles';
import { isGivingOldTheme } from '@pushpay/theming';
const height = '14px';
const radius = multiply(height, 0.5);
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'inline-flex',
    position: 'relative'
  },
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    background: isGivingOldTheme(theme) ? theme.colors['palette-blue'] : theme.colors['product-color'],
    borderRadius: radius,
    color: theme.colors['palette-white'],
    display: 'flex',
    fontSize: '12px',
    lineHeight: 1,
    height,
    minWidth: height,
    padding: '0 0.25em',
    position: 'absolute',
    right: -3,
    top: -3,
    transform: 'translate(25%, -25%)'
  }
}));
const MAX_POSSIBLE_COUNT = 99;

const Badge = props => {
  const {
    'data-pp-at-target': targetId,
    className: classNameProp,
    classes: classesProp,
    children,
    count,
    max = MAX_POSSIBLE_COUNT,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);

  if (count && count > 0) {
    return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
      className: className
    }), children, /*#__PURE__*/React.createElement("span", {
      className: classes.badge
    }, count <= max ? count : `${max}+`));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export default Badge;